import { useEffect, useState, useContext } from 'react';
import { Context as AuthContext } from '../../contexts/AuthContext';
import DataTable from '../../components/Core/DataTable';
import { createOptionsPage } from '../../entities/OptionsPaged';
import { createPagedMeta } from '../../entities/PagedMeta';
import { LogHistoryListColumns } from '.';
import isAdmin from '../../helpers/isAdmin';
import isUpperManagement from '../../helpers/isUpperManagement';
import LogHistory from '../../services/LogHistory';

const LogHistoryList = ({ entityId = null, entity = null }: { entityId?: string | null; entity?: string | null }) => {
  const { user, token, currentSchool }: any = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState<any>([]);
  const [filteredOptions, setFilteredOptions] = useState({
    filters: [
      {
        field: 'entityId',
        operation: 'hash',
        value: entityId,
      },
      {
        field: 'entity',
        operation: '=',
        value: entity,
      },
    ],
    options: createOptionsPage(createPagedMeta(), { sortDesc: 'desc' }),
  });
  const [view, setView] = useState('');

  const handlePerRowsChange = async (perPage: number) => {
    const newOptions = {
      ...createPagedMeta(),
      perPage,
    };
    const newFilteredOptions = {
      filters: filteredOptions.filters,
      options: createOptionsPage(newOptions, { sortDesc: 'desc' }),
    };
    setFilteredOptions(newFilteredOptions);
  };

  const handlePageChange = async (page: number) => {
    const newOptions = {
      ...createPagedMeta(),
      currentPage: page,
    };
    const newFilteredOptions = {
      filters: filteredOptions.filters,
      options: createOptionsPage(newOptions, { sortDesc: 'desc' }),
    };
    setFilteredOptions(newFilteredOptions);
  };

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const response = await LogHistory(token).listBySchool(currentSchool.value, filteredOptions);
        setTableData({
          meta: response.meta,
          data: response.data.map((r: any) => {
            return { ...{ selected: false }, ...r };
          }),
        });
      } catch (e) {
        console.error('Failed to load pay rates');
      } finally {
        setLoading(false);
      }
    };
    if (isAdmin(user) || isUpperManagement(user)) load();
  }, [filteredOptions]);

  useEffect(() => {
    const newFilters = filteredOptions.filters.filter((f) => f.field !== 'actionType');
    if (view !== '') {
      newFilters.push({ field: 'actionType', operation: '=', value: view });
    }
    setFilteredOptions({
      ...filteredOptions,
      filters: newFilters,
    });
  }, [view]);

  return (
    <>
      <form>
        <h6 className="heading-small text-muted mb-2">{`${entity} History`}</h6>
        <DataTable
          columns={LogHistoryListColumns({
            showEntityCollumn: false,
          })}
          data={tableData.data}
          totalRows={tableData.meta?.total}
          loading={loading}
          title=""
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
          isFilterButtons={true}
          filtersList={[
            { value: '', label: 'All' },
            ...Object.keys(tableData?.meta?.options?.validActionTypes || {}).map((key) => ({
              value: key,
              label: tableData?.meta?.options?.validActionTypes[key],
            })),
          ]}
          onChangeFilter={(e) => {
            setView(e);
          }}
        />
      </form>
    </>
  );
};

export default LogHistoryList;
